
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import FormField from '@/components/forms/FormField.vue';

import { Actions, Getters } from '@/store/enums/TemplateEnums';

/**
 * TODO:
 *
 * Recreate this component when the backend start creating auto-generated
 * passwords
 */

export default defineComponent({
  name: 'placeholder-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'w-100',
      type: String,
    },
    name: {
      default: 'placeholder',
      type: String,
    },
    label: {
      default: 'Insert Placeholder',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    options: {
      default: null,
      type: Array,
    },
    selectPlaceholder: {
      default: `Insert Placeholder`,
      type: String,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
});
